/**************************************************
 * Nombre:       Seccion_Sostenibilidad
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Sostenibilidad_Portada from "./Componentes/Sostenibilidad_Portada";
import Sostenibilidad_Post from "./Componentes/Sostenibilidad_Post";
import Equipo from "./Componentes/Equipo";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Sostenibilidad = () => {
    const {sCell} = useResponsive()

    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Sostenibilidad_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 14}}>
                <Sostenibilidad_Post/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                <Equipo/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Sostenibilidad